import React, { useEffect, useState, useContext } from 'react';
import { motion } from 'framer-motion';

import MainNavigation from '../../components/MainNavigation';
import InterviewList from '../components/InterviewList';
import ErrorModal from '../../shared/components/UIElements/ErrorModal';
import LoadingSpinner from '../../shared/components/UIElements/LoadingSpinner';
import { useHttpClient } from '../../shared/hooks/http-hook';
import { AuthContext } from '../../shared/context/auth-context';
import './Home.css';
import LineChart from '../components/LineChart';
import Button from '../../shared/components/FormElements/Button/Button';

const Home = () => {
    const auth = useContext(AuthContext);
    const [userData, setUserData] = useState();
    const { isLoading, error, sendRequest, clearError } = useHttpClient();
    const [loadedInterviews, setLoadedInterviews] = useState();
    const [plan, setPlan] = useState('free');

    useEffect(()=>{
        const fetchInterviews = async () => {
            try {
                const responseData = await sendRequest(process.env.REACT_APP_BACKEND_URL_PLAN+`/user/${auth.userId}/interviews`, 'GET', null, {Authorization:'Bearer '+ auth.token});

                setLoadedInterviews(responseData.interviews);
                let numEvalRecord = responseData.user.numEvalRecord;
                if (numEvalRecord.length > 10) {
                    numEvalRecord = responseData.user.numEvalRecord.slice(-10);
                }
                setPlan(responseData.user.plan);
                setUserData({
                    labels: numEvalRecord.map((data) => {
                        return new Date(data.date).toLocaleDateString()
                    }),
                    datasets: [
                        {
                            label: 'Evaluation',
                            data: numEvalRecord.map((data) => {
                                return data.numEval
                            }),
                            borderColor: 'rgb(110, 111, 247, 1)',
                            backgroundColor: (context) => {
                                const bgColor = [
                                    'rgb(110, 111, 247, 0.8)',
                                    'rgb(110, 111, 247, 0.6)',
                                    'rgb(110, 111, 247, 0.4)',
                                    'rgb(110, 111, 247, 0.2)',
                                ]
            
                                if (!context.chart.chartArea) {
                                    return;
                                }
                                const { ctx, data, chartArea:{top, bottom} } = context.chart;
                                const gradientBg = ctx.createLinearGradient(0, top, 0, bottom);
                                gradientBg.addColorStop(0, bgColor[0]);
                                gradientBg.addColorStop(0.33, bgColor[1]);
                                gradientBg.addColorStop(0.66, bgColor[2]);
                                gradientBg.addColorStop(1, bgColor[3]);
            
                                return gradientBg;
                            },
                            fill: true
                        }
                    ]
                });
            } catch (err) {
            }
        };
        fetchInterviews();
    }, [sendRequest, auth]);

  const interviewDeleteHandler = (deletedInterviewId) => {
    setLoadedInterviews(prevInterviews=>prevInterviews.filter(interview => interview._id !== deletedInterviewId));
  };
    
  return <React.Fragment>
    {!isLoading && <MainNavigation />} 
    <div className='home-page'>
    <ErrorModal error={error} onClear={clearError} />
    {isLoading && <div className='center'>
        <LoadingSpinner asOverlay />
    </div>}
        {!isLoading && loadedInterviews && <motion.div 
        className="home-titles"
        initial={{ opacity: 0, scale: 1 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ delay: 0.25, duration: 0.5 }}
        exit={{ opacity: 0, scale: 1 }}
        >
            <h1 style={{ fontSize: '48px' }}>Home</h1>
            <p>We help you prepare for your interview based on your skill set, background, and resume to uniquely tailor you preparation and track progress over time.</p>
        </motion.div>}
        {!isLoading && loadedInterviews && (plan === 'free') &&
            <motion.div 
            className='home-details'
            initial={{ opacity: 0, scale: 1 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ delay: 0.25, duration: 0.5 }}
            exit={{ opacity: 0, scale: 1 }}
            >
            
            <div className='home-list'>
                <h3>Sessions:</h3>
                <InterviewList items={loadedInterviews} onDeleteInterview={interviewDeleteHandler} />
            </div>
            <div className='home-chart'>
                <h3>Progress:</h3>
                <div className='chart-div-free'>
                    <LineChart chartData={userData} options={{responsive: true}}/>
                </div>
            </div>
            </motion.div>}
            {!isLoading && loadedInterviews && (plan === 'pro') &&
            <motion.div 
            className='home-details'
            initial={{ opacity: 0, scale: 1 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ delay: 0.25, duration: 0.5 }}
            exit={{ opacity: 0, scale: 1 }}
            >
            
            <div className='home-list'>
                <h3>Sessions:</h3>
                <InterviewList items={loadedInterviews} onDeleteInterview={interviewDeleteHandler} />
            </div>
            <div className='home-chart'>
                <h3>Progress:</h3>
                <div className='chart-div'>
                    <LineChart chartData={userData} options={{responsive: true,}}/>
                </div>
            </div>
            </motion.div>}
    </div>
    </React.Fragment>;
};


export default Home;